import { render } from 'preact';
import { App } from './App';
import './styles/globals.css';

const root = document.getElementById('app');
if (!root) throw new Error('missing #app root');
render(<App />, root);
